export default __webpack_public_path__ + "static/media/logo03.7a5966f7.svg";